import { GridColDef } from "@mui/x-data-grid";

export const columns: GridColDef[] = [
    { field: 'evaluatorName', headerName: 'Name', flex: 1 },
    { field: 'evaluatorEmail', headerName: 'Email', flex: 1 },
    { field: 'courseLevels', headerName: 'Course levels', flex: 2 },
    { field: 'moduleCategories', headerName: 'Modules categories', flex: 2 }
];

